import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";
import { alerts } from "@/mocks/home";

const levelStyle: Record<string, string> = {
  高危: "bg-primary-100 text-primary-800 border-primary-200",
  关注: "bg-accent-100 text-accent-800 border-accent-200",
  提示: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export default function AlertSection() {
  return (
    <section id="alerts" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <Reveal>
          <SectionHeading
            index="04"
            eyebrow="Risk Alert"
            title="风险预警 · 线报速览"
            description="正在发生的骗局与正在扩散的话术，我们尽量抢在它到达你之前先发出来。"
          />
        </Reveal>

        <Reveal delay={60}>
          <div className="mt-8 flex items-center gap-4 overflow-hidden rounded-md border border-background-200 bg-background-100 py-3">
            <span className="flex shrink-0 items-center gap-2 border-r border-background-300 px-4 text-xs tracking-[0.2em] text-primary-600">
              <span className="h-1.5 w-1.5 animate-hw-pulse rounded-full bg-primary-500"></span>
              实时
            </span>
            <div className="relative flex-1 overflow-hidden">
              <div className="flex w-max animate-hw-marquee gap-10 whitespace-nowrap pr-10">
                {[...alerts, ...alerts].map((item, index) => (
                  <span key={`${item.title}-${index}`} className="text-sm text-foreground-600">
                    {item.date} · {item.title}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>

        <ul className="mt-10 divide-y divide-background-200 border-t border-background-200">
          {alerts.map((item, index) => (
            <Reveal key={item.title} delay={index * 50}>
              <li className="group flex cursor-pointer flex-col gap-3 py-6 md:flex-row md:items-start md:gap-8">
                <div className="flex shrink-0 items-center gap-3 md:w-44 md:flex-col md:items-start md:gap-2">
                  <span
                    className={`rounded-full border px-3 py-1 text-xs ${
                      levelStyle[item.level] ?? levelStyle["提示"]
                    }`}
                  >
                    {item.level}
                  </span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading text-base leading-7 text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-7 text-foreground-600">{item.brief}</p>
                </div>
                <i className="ri-arrow-right-line hidden shrink-0 text-lg text-foreground-300 transition-colors group-hover:text-primary-500 md:block"></i>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}